import React, { useEffect } from "react";
import "tailwindcss/tailwind.css";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Login from "./pages/login/Login";
import Events from "./pages/events/Events";
import Profile from "./pages/profile/Profile";
import People from "./pages/people/People";
import Notification from "./pages/notifications/Notifications";
import ProfileQR from "./pages/profile/ProfileQR";
import LoginOtp from "./pages/login/LoginOtp";
import LoginDemoEvent from "./pages/login/LoginDemoEvent";
import LoginUserDetails from "./pages/login/LoginUserDetails";
import Connections from "./pages/connections/Connections";
import ConnectionsScan from "./pages/connections/ConnectionsScan";
import UserProfile from "./pages/userProfile/UserProfile";
import PageNotFound from "./pages/pageNotFound/PageNotFound";
import AttendeeEvents from "./pages/attendeeEvents/AttendeeEvents";
import AttendeeSingleEvent from "./pages/attendeeEvents/AttendeeSingleEvent";
import EventHomeLayout from "./common/layout/EventHomeLayout";
import AuthWrapper from "./AuthWrapper";
import EventLayout from "./components/eventLayout/EventLayout";
import Layout from "./common/layout/Layout";

const AllRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/login");
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      {/* ---------Dashboard layout (Routes which require side menu and navbar) */}

      <Route element={<EventHomeLayout />}>
        <Route element={<AuthWrapper />}>
          <Route path="/events/:eventId" element={<EventLayout />} />
        </Route>
      </Route>

      {/* --------- Layout without side menu (Routes which require side menu and navbar) */}
      <Route element={<Layout />}>
        {/* main events route */}
        <Route path="/events" element={<Events />} />

        {/* exhibitor/sponsor routes */}

        {/* Attendee protected routes*/}
        <Route path="/attendee" element={<AttendeeEvents />} />
        <Route element={<AuthWrapper />}>
          <Route path="/attendee/:eventId" element={<AttendeeSingleEvent />} />
        </Route>

        {/* {OEM} protected routes */}

        {/* {Create event Page Routes} */}

        {/* {Login Routes} */}
        <Route path="/login" element={<Login />} />
        <Route path="/login/otp" element={<LoginOtp />} />
        <Route path="/login/demoevent" element={<LoginDemoEvent />} />
        <Route path="/login/userdetails" element={<LoginUserDetails />} />

        {/* {Profile Routes} */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/qr" element={<ProfileQR />} />

        {/* {People Routes} */}
        <Route path="/people" element={<People />} />

        {/* {Notification Routes} */}
        <Route path="/notifications" element={<Notification />} />

        {/* {connections Routes} */}
        <Route path="/connections" element={<Connections />} />
        <Route path="/connections/scan" element={<ConnectionsScan />} />

        {/* {UserProfile Routes} */}
        <Route path="/userprofile" element={<UserProfile />} />

        {/* {Waitlist Routes} */}

        {/* {Onsite Registration Route} */}

        {/* {settings route} */}

        {/* other routes */}
      </Route>

      {/* routes without layout (without sidebar and navbar) --------------*/}

      {/* <Route path="/connections/user" element={<BadgeRedirection />} /> */}

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AllRoutes;
